export default __webpack_public_path__ + "static/media/danger.9175d1a1.svg";